export type Department =
  | "project-director"
  | "marketing"
  | "trading"
  | "revenue";

export type ReportType =
  | "executive-brief"
  | "marketing-calendar"
  | "trading-risk-matrix"
  | "product-blueprint";

export type AppRole = "admin" | "member";

export interface AppUser {
  id: string;
  email: string;
  name: string;
  role: AppRole;
}

export interface Report {
  id: string;
  user_id: string;
  department: Department;
  type: ReportType;
  title: string;
  content: string;
  meta: Record<string, unknown>;
  created_at: string;
}

export type ProjectStatus = "backlog" | "in-progress" | "review" | "done";

export interface Project {
  id: string;
  owner_id: string;
  title: string;
  description: string;
  department: Department;
  status: ProjectStatus;
  created_at: string;
}

export interface AuditLog {
  id: string;
  user_id: string | null;
  user_email: string;
  action: string;
  target: string | null;
  created_at: string;
}

export interface AdminUserRow {
  id: string;
  email: string;
  name: string;
  role: AppRole;
  created_at: string;
}

export const DEPARTMENTS: Record<Department, { label: string; short: string; accent: string }> = {
  "project-director": { label: "Enterprise Project Director", short: "Projects", accent: "from-blue-500 to-indigo-600" },
  marketing: { label: "Digital Marketing & Brand Strategist", short: "Marketing", accent: "from-pink-500 to-rose-600" },
  trading: { label: "Automated Trading Systems Engineer", short: "Trading", accent: "from-amber-500 to-orange-600" },
  revenue: { label: "Automated Revenue Architect", short: "Revenue", accent: "from-emerald-500 to-teal-600" },
};
